import { Avatar, Image, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import config, {
  APP_LOGO_SRC,
  APP_LOGO_SRC_COLLAPSED,
  APP_LOGO_SRC_COLLAPSED_COLOR,
  APP_LOGO_SRC_COLOR,
  APP_THEME,
  CURRENT_APP_THEME,
} from '../const/config';
import logoRamus from '../assets/images/logo-base64/logo-ramus';
import logoPinisiWhite from '../assets/images/logo-base64/logo-pinisi';
import logoNetra from '../assets/images/logo-base64/logo-netra';
import logoBKI from '../assets/images/logo-base64/logo-bki';
import logoArnantara from '../assets/images/logo-base64/logo-arnantara';

type AppLogoProps = {
  collapsed: boolean;
  color?: 'white' | 'color';
};

const AppLogo: React.FC<AppLogoProps> = ({ collapsed, color = 'color' }) => {
  return (
    <LogoContainer collapsed={collapsed} className='logo-container'>
      {collapsed && config.sidebar.logoType === 'image-and-text' ? (
        <Image
          preview={false}
          width={50}
          src={
            APP_THEME === CURRENT_APP_THEME.ARNANTARA
              ? logoArnantara
              : APP_THEME === CURRENT_APP_THEME.BKI
              ? logoBKI
              : APP_THEME === CURRENT_APP_THEME.NETRA
              ? logoNetra
              : APP_THEME === CURRENT_APP_THEME.PINISI
              ? logoPinisiWhite
              : logoRamus
          }
          style={{
            objectFit: 'cover',
          }}
        />
      ) : (
        <AppTitle>
          {config.sidebar.logoType === 'image-and-text' && (
            <Image
              preview={false}
              style={{
                width:
                  APP_THEME === CURRENT_APP_THEME.BKI
                    ? 'auto'
                    : APP_THEME === CURRENT_APP_THEME.NETRA
                    ? 120
                    : APP_THEME === CURRENT_APP_THEME.ARNANTARA
                    ? 140
                    : APP_THEME === CURRENT_APP_THEME.PINISI
                    ? 90
                    : 80,
                height:
                  APP_THEME === CURRENT_APP_THEME.BKI
                    ? 30
                    : APP_THEME === CURRENT_APP_THEME.PINISI
                    ? 40
                    : 'auto',
                objectFit:
                  APP_THEME === CURRENT_APP_THEME.PINISI ? 'cover' : 'contain',
              }}
              src={
                APP_THEME === CURRENT_APP_THEME.BKI
                  ? logoBKI
                  : APP_THEME === CURRENT_APP_THEME.NETRA
                  ? logoNetra
                  : APP_THEME === CURRENT_APP_THEME.PINISI
                  ? logoPinisiWhite
                  : APP_THEME === CURRENT_APP_THEME.ARNANTARA
                  ? logoArnantara
                  : logoRamus
              }
            />
          )}
        </AppTitle>
      )}
    </LogoContainer>
  );
};

type LogoContainerProps = {
  collapsed: boolean;
};

const LogoContainer = styled.div<LogoContainerProps>`
  padding: ${({ collapsed }) => (collapsed ? '0' : '0px 24px')};
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: ${({ collapsed }) => (collapsed ? 'center' : 'flex-start')};
`;

const AppTitle = styled.div`
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const AppAvatar = styled(Avatar)`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export default AppLogo;
